<ng-container *ngIf="isDirectMode; else profileUploaderTemplate">
    <div
        class="direct-uploader"
        (appDropZone)="onDrop($event)">
        <input
            #fileInput
            [id]="fileInputId"
            type="file"
            class="hidden"
            [accept]="accept"
            (change)="fileChangeEvent($event)" />

        <div class="direct-uploader__preview" [class.direct-uploader__preview--empty]="!previewImageUrl">
            <img *ngIf="previewImageUrl" [src]="previewImageUrl" alt="" />
            <div *ngIf="!previewImageUrl" class="direct-uploader__empty">
                <fa-icon [icon]="['fal', 'cloud-arrow-up']" [size]="'2x'"></fa-icon>
                <span>Upload image</span>
            </div>
            <div *ngIf="uploadState === uploadStates.uploading" class="direct-uploader__progress">
                <span [style.width.%]="progress || 0"></span>
            </div>
        </div>

        <div class="direct-uploader__actions">
            <label class="direct-uploader__button direct-uploader__button--primary" [attr.for]="fileInputId">
                <fa-icon [icon]="['fal', previewImageUrl ? 'arrows-rotate' : 'cloud-arrow-up']"></fa-icon>
                <span>{{ previewImageUrl ? 'Replace' : 'Upload' }}</span>
            </label>
            <button
                type="button"
                class="direct-uploader__button"
                [disabled]="!previewImageUrl || uploadState === uploadStates.uploading"
                (click)="deleteImage()">
                <fa-icon [icon]="['fal', 'trash-alt']"></fa-icon>
                <span>Remove</span>
            </button>
        </div>

        <div *ngIf="uploadState === uploadStates.uploading" class="direct-uploader__meta">
            Uploading {{ progress || 0 }}%
        </div>
        <div *ngIf="uploadError" class="direct-uploader__error">
            {{ uploadError }}
        </div>
    </div>
</ng-container>

<ng-template #profileUploaderTemplate>
<div class="mx-auto w-full px-3 sm:px-4 lg:px-6">

    <!-- Mobile Tabs -->
    <div class="block lg:hidden mb-4">
        <div class="border-b border-gray-200">
            <nav class="-mb-px flex space-x-4 sm:space-x-8" aria-label="Tabs">
                <button (click)="activeTab = 'upload'" 
                    [class.border-blue-500]="activeTab === 'upload'"
                    [class.text-blue-600]="activeTab === 'upload'"
                    [class.border-transparent]="activeTab !== 'upload'"
                    [class.text-gray-500]="activeTab !== 'upload'"
                    class="whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm">
                    Yükleme/Düzenleme
                </button>
                <button (click)="activeTab = 'preview'" 
                    [class.border-blue-500]="activeTab === 'preview'"
                    [class.text-blue-600]="activeTab === 'preview'"
                    [class.border-transparent]="activeTab !== 'preview'"
                    [class.text-gray-500]="activeTab !== 'preview'"
                    class="whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm">
                    Önizleme
                </button>
            </nav>
        </div>
    </div>

    <div class="mx-auto grid grid-cols-1 items-start gap-4 sm:gap-6 lg:gap-8 max-w-md sm:max-w-lg lg:max-w-5xl lg:grid-cols-2">

        <!-- Preview -->
        <div class="relative" [class.hidden]="activeTab !== 'preview'" [class.lg:block]="true">

            <div class="relative z-20 mx-0 sm:mx-2 lg:-mx-4 shadow-lg ring-1 ring-slate-900/10 lg:mx-0 rounded-2xl">
                <div class="flex absolute -bottom-px left-1/2 -ml-20 sm:-ml-48 h-[2px] w-40 sm:w-96">
                    <div
                        class="w-full flex-none blur-sm [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]">
                    </div>
                    <div
                        class="-ml-[100%] w-full flex-none blur-[1px] [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]">
                    </div>
                    <div
                        class="-ml-[100%] w-full flex-none blur-sm [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]">
                    </div>
                    <div
                        class="-ml-[100%] w-full flex-none blur-[1px] [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]">
                    </div>
                </div>

                <div class="relative grid place-items-center image-container bg-slate-800 bg-cover bg-center rounded-2xl h-[60vh] sm:h-[50vh] lg:min-h-[400px]"
                    [style.background-image]="previewImageUrl ? 'url(' + previewImageUrl + ')' : 'none'">
                    <div
                        class="absolute inset-0 flex flex-col justify-center items-center backdrop-filter backdrop-blur-md z-10 rounded-2xl">
                        <div
                            class="absolute top-2 left-2 right-2 flex items-center p-2 sm:p-3 justify-between bg-black bg-opacity-60 rounded-2xl z-20">
                            <fa-icon [icon]="['fal', 'cauldron']" class="text-white flex-shrink-0" [size]="'lg'"></fa-icon>
                            <div class="ml-2 sm:ml-3 flex-1 min-w-0">
                                <h2 class="text-xs sm:text-sm font-semibold leading-4 sm:leading-5 text-white truncate">
                                    {{'SystemAdmin.Components.ImageUploader.Properties.AIDetect.Title' | translate}}
                                </h2>
                                <p class="text-xs leading-3 sm:leading-4 text-slate-300 truncate">
                                    {{'SystemAdmin.Components.ImageUploader.Properties.AIDetect.Description' |
                                    translate}}</p>
                            </div>

                            <div class="ml-2 flex-shrink-0">
                                <app-toggle-switch [(ngModel)]="aiCrop" [onIcon]="['fas', 'wand-magic-sparkles']"
                                    [offIcon]="['fal','wand-magic-sparkles']"></app-toggle-switch>
                            </div>

                        </div>


                        <div
                            class="flex items-center justify-center w-24 h-24 sm:w-32 sm:h-32 rounded-full overflow-hidden ring-4 ring-white z-20 mx-auto">
                            <img [src]="previewImageUrl"
                                class="object-cover w-full h-full overflow-hidden rounded-full hover:scale-125 transition duration-500 ease-in-out">
                            <div *ngIf="progress>0 && progress<100" role="progressbar" aria-valuenow="0"
                                aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'--value': progress}">
                            </div>
                        </div>

                        <div [class.opacity-100]="successMessage" [class.opacity-0]="!successMessage"
                            class="absolute flex items-center justify-center h-12 sm:h-14 bottom-2 left-2 right-2 z-30 bg-green-500 bg-opacity-80 rounded-2xl text-white shadow-lg transition-opacity duration-1000 ease-in">
                            <span class="text-sm sm:text-base font-medium">{{"Image Uploaded Successfully"}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Upload Image -->
        <div class="relative" (appDropZone)="onDrop($event)" [class.hidden]="activeTab !== 'upload'" [class.lg:block]="true">

            <div class="relative z-20 mx-0 sm:mx-2 lg:-mx-4 shadow-lg ring-1 ring-slate-900/10 lg:mx-0 rounded-2xl">
                <div class="flex absolute -bottom-px left-1/2 -ml-20 sm:-ml-48 h-[2px] w-40 sm:w-96">
                    <div
                        class="w-full flex-none blur-sm [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]">
                    </div>
                    <div
                        class="-ml-[100%] w-full flex-none blur-[1px] [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]">
                    </div>
                    <div
                        class="-ml-[100%] w-full flex-none blur-sm [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]">
                    </div>
                    <div
                        class="-ml-[100%] w-full flex-none blur-[1px] [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]">
                    </div>
                </div>
                <div class="relative image-container bg-slate-100 rounded-2xl h-[60vh] sm:h-[50vh] lg:min-h-[400px]">

                    <ng-container *ngIf="fileSelected;else imageUploadTemplate">

                        <!-- Close Button -->
                        <div class="absolute flex justify-end top-2 left-2 right-2 z-10 pointer-events-none">
                            <button (click)="deleteImage()" mat-icon-button>
                                <mat-icon class="text-white pointer-events-auto" [svgIcon]="'fal:circle-xmark'">
                                </mat-icon>
                            </button>
                        </div>

                        <image-cropper *ngIf="!aiCrop" class="block rounded-2xl" [imageChangedEvent]="imageChangedEvent"
                            [maintainAspectRatio]="true" [containWithinAspectRatio]="containWithinAspectRatio"
                            [aspectRatio]="1 / 1" [onlyScaleDown]="true" [roundCropper]="true" [resizeToWidth]="1024"
                            [canvasRotation]="canvasRotation" [transform]="transform" [alignImage]="'center'"
                            [style.display]="showCropper ? null : 'none'" format="jpeg"
                            (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
                            (cropperReady)="cropperReady($event)" (loadImageFailed)="loadImageFailed()"
                            style="--cropper-outline-color:rgb(0,0,0,0.5);--cropper-overlay-color:rgb(0,0,0,0.5)"></image-cropper>

                        <img *ngIf="aiCrop" [src]="sourceImageUrl" class="object-cover block w-full h-full rounded-2xl">

                        <!-- Editors -->
                        <div *ngIf="!aiCrop"
                            class="absolute flex items-center justify-center h-12 sm:h-14 bottom-2 left-2 right-2 z-10 bg-black bg-opacity-50 rounded-2xl">

                            <div class="flex items-center justify-center space-x-1 sm:space-x-2">
                                <button (click)="rotateLeft()" class="p-1 sm:p-2" mat-icon-button>
                                    <mat-icon class="text-white text-lg sm:text-xl" [svgIcon]="'fal:arrow-rotate-left'">
                                    </mat-icon>
                                </button>
                                <button (click)="flipHorizontal()" class="p-1 sm:p-2" mat-icon-button>
                                    <svg class="text-white mx-auto w-5 h-6 sm:w-6 sm:h-8" stroke-width="1.5"
                                        viewBox="0 -4 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.5 12V14" stroke="currentColor" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M5.75 12L4.8125 14" stroke="currentColor" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M7.625 20H9.5V18" stroke="currentColor" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M3.875 20H2L2.9375 18" stroke="currentColor" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M7.625 8L9.5 4V8" stroke="currentColor" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M14.5 20H22L14.5 4V20Z" stroke="currentColor" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </button>
                                <button (click)="rotateRight()" class="p-1 sm:p-2" mat-icon-button>
                                    <mat-icon class="text-white text-lg sm:text-xl" [svgIcon]="'fal:arrow-rotate-right'">
                                    </mat-icon>
                                </button>
                            </div>


                        </div>


                    </ng-container>

                    <ng-template #imageUploadTemplate>

                        <div class="flex items-center justify-center w-full h-full p-4 sm:p-8">
                            <label [attr.for]="fileInputId"
                                class="flex flex-col items-center justify-center w-full h-full border-2 border-gray-300 border-dashed rounded-2xl cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                                <div class="flex flex-col items-center justify-center p-3 sm:p-5 h-full">
                                    <fa-icon [icon]="['fal', 'cloud-arrow-up']" [size]="'2x'"
                                        class="text-gray-400 mb-2 sm:mb-3"></fa-icon>
                                    <div class="text-center text-sm sm:text-base"
                                        [innerHTML]="'SystemAdmin.Components.ImageUploader.Dropzone.Description' | translate">
                                    </div>
                                </div>
                                <input [id]="fileInputId" type="file" class="hidden" [accept]="accept" (change)="fileChangeEvent($event)"
                                    #fileInput />
                            </label>
                        </div>


                    </ng-template>

                </div>
            </div>
        </div>

    </div>

    <div *ngIf="uploadState!=uploadStates.pending"
        class="flex justify-center mt-4 sm:mt-6 mb-4 px-0 sm:px-2">
        <button (click)="cancelUpload()" *ngIf="uploadState==uploadStates.uploading"
            class="bg-red-500 hover:bg-red-700 text-white font-semibold py-3 px-6 rounded-xl text-sm sm:text-base shadow-lg transition-all duration-200 hover:shadow-xl"
            type="button">{{'SystemAdmin.Components.ImageUploader.Toolbar.CancelUpload' | translate}}</button>

        <button (click)="close()" *ngIf="uploadState!=uploadStates.uploading"
            class="bg-red-500 hover:bg-red-700 text-white font-semibold py-3 px-6 rounded-xl text-sm sm:text-base shadow-lg transition-all duration-200 hover:shadow-xl"
            type="button">{{'SystemAdmin.Components.ImageUploader.Toolbar.Close' | translate}}</button>
    </div>

    <div *ngIf="uploadState==uploadStates.pending" class="flex flex-col sm:grid sm:grid-cols-2 gap-3 sm:gap-4 mt-4 sm:mt-6 mb-4 px-0 sm:px-2">
        <div class="order-1">
            <button (click)="uploadFile()"
                class="bg-green-500 hover:bg-green-700 text-white font-semibold py-3 px-4 rounded-xl text-sm sm:text-base w-full shadow-lg transition-all duration-200 hover:shadow-xl"
                type="button">{{'SystemAdmin.Components.ImageUploader.Toolbar.UploadImage' | translate}}</button>
        </div>

        <div class="order-2">
            <button (click)="close()" class="bg-red-500 hover:bg-red-700 text-white font-semibold py-3 px-4 rounded-xl text-sm sm:text-base w-full shadow-lg transition-all duration-200 hover:shadow-xl"
                type="button">{{'SystemAdmin.Components.ImageUploader.Toolbar.Close' | translate}}</button>
        </div>
    </div>


</div>
</ng-template>
